import { useState } from 'react';
import moment from 'moment/moment';
import { message } from 'antd';
import { getOrderFromBiartic, sendOrderToBiartic } from '../../../services/optometry';

const UseExamIntegration = () => {
  const [loading, setLoading] = useState({
    order: false,
    orderRequest: false,
  });
  const [showModal, setShowModal] = useState(false);
  const [orderData, setOrderData] = useState(null);

  const dateTranslationShort = (isoDate) => {
    const date = moment(isoDate).utcOffset(-180);
    return date.locale('es-CL').format('DD [de] MMMM [a las] HH:mm [hrs]');
  };

  const handleMessageError = (text) => {
    message.error({
      content: text,
      style: { marginTop: '45vh', fontSize: 16 },
    });
  };

  const fetchOrder = async (admissionPatientId) => {
    if (!admissionPatientId) return;

    setLoading((loading) => ({ ...loading, order: true }));
    try {
      const response = await getOrderFromBiartic({ admissionPatientId });
      setOrderData(response?.statusCode === 200 ? response.order : null);
    } catch (error) {
      console.error(`Error al obtener integración de examen: ${error}`);
      handleMessageError(`Error al obtener integración de examen: ${error}`);
    } finally {
      setLoading((loading) => ({ ...loading, order: false }));
    }
  };

  const handleRequestOrder = async (admissionPatientId) => {
    setLoading((loading) => ({ ...loading, orderRequest: true }));

    try {
      const response = await sendOrderToBiartic({ admissionPatientId });

      if (response?.statusCode === 200) {
        message.success({
          content: 'Orden solicitada correctamente',
          style: { marginTop: '45vh', fontSize: 16 },
        });
        await fetchOrder(admissionPatientId);
      } else {
        handleMessageError(response?.message || 'Error al solicitar orden de optometría');
      }
    } catch (error) {
      handleMessageError('Error al solicitar orden de optometría');
      console.error(error);
    } finally {
      setLoading((loading) => ({ ...loading, orderRequest: false }));
    }
  };

  return {
    loading,
    showModal,
    setShowModal,
    orderData,
    fetchOrder,
    handleRequestOrder,
    dateTranslationShort,
  };
};

export default UseExamIntegration;